var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnglesLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98074 8.50083L8.54285 3.93872C8.95789 3.52368 8.95789 2.85132 8.54285 2.43628C8.12781 2.02124 7.45545 2.02124 7.04041 2.43628L1.72791 7.74878C1.31287 8.16382 1.31287 8.83618 1.72791 9.25122L7.04041 14.5637C7.24627 14.7729 7.51853 14.8758 7.7908 14.8758C8.06306 14.8758 8.33467 14.7721 8.54185 14.5645C8.95689 14.1495 8.95689 13.4771 8.54185 13.0621L3.98074 8.50083ZM10.3574 8.50083L14.9195 3.93872C15.3346 3.52368 15.3346 2.85132 14.9195 2.43628C14.5045 2.02124 13.8321 2.02124 13.4171 2.43628L8.10457 7.74878C7.68953 8.16382 7.68953 8.83618 8.10457 9.25122L13.4171 14.5637C13.6213 14.7729 13.8935 14.8758 14.1658 14.8758C14.4381 14.8758 14.7097 14.7721 14.9169 14.5645C15.3319 14.1495 15.3319 13.4771 14.9169 13.0621L10.3574 8.50083Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnglesLeft);
export default __webpack_public_path__ + "static/media/angles-left.51bee88b441dc37867fe2b2e5637b478.svg";
export { ForwardRef as ReactComponent };